export const color = {
    'VERY_LOW': '#FF6666', // Darker Light Red
    'LOW': '#FF6666',      // Darker Light Orange
    'NORMAL': '#FFFF66',   // Darker Light Yellow
    'HIGH': '#339933'      // Darker Light Green
};